export const camelize = (str) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
    return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
  }).replace(/[\s-]+/g, '');
};



// WEBPACK FOOTER //
// ./src/utils/camelize.js